import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Apresentacao, Criticals, PfIndicator, PfIndTable } from '../../models/apresentacao.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Graph } from '../../models/itens.model';
import { SharedService } from '../../services/shared.service';
import { Location } from '@angular/common';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-apresentacao-slide',
  templateUrl: './apresentacao-slide.component.html',
  styleUrls: ['./apresentacao-slide.component.scss', './../../reuniao.scss']
})
export class ApresentacaoSlideComponent extends BaseFormComponent<Apresentacao>  implements OnInit {
  
  id:number;
  slide:number;
  @Input() slideIndex:number;
  @Input() print:boolean = false;
  @Output() graficoCarregado = new EventEmitter<void>();  
  filters:any;
  timers:any;
  indicators:PfIndicator[] = [];
  currentIndicator:PfIndicator = null;
  currentCritical:Criticals = null;
  currentModalId:string = '';
  showDetails:boolean = true;
  currentIndex = 0;
  currentGraph = null;
  currentFiles = null;
  visibleItems = 1;
  currentSubPage:string = 'analysis';
  modalRef?: BsModalRef;
  interval: any;
  listSlide = [];
  statusAdm:boolean = false;
  subPages = {
    'analysis': 'Análise',
    'previous': 'Exercícios anteriores',
    'done': 'Realizado',
    'graph': 'Gráfico'
  };
  status = {'0':'Sem informação','1':'Igual ou superior a 90.00','2':'Entre 70.00 e 90.00','3':'Abaixo de 70.00'};
  analysis = {'0':'Sem Meta','1':'Atingir a meta',
    '2':'Algumas dificuldades para atingir a meta',
    '3':'Pouco provável que a meta seja atingida'};
  polar= {'1':'Se maior, melhor', '3':'Se menor, melhor'};

  iconLupa:any =  this.setFilePath('lupa_dados.svg');
  iconOrcamento:any =  this.setFilePath('orcamento.svg');
  iconPersons:any =  this.setFilePath('group.svg');
  iconBudget:any =  this.setFilePath('budget.svg');
  iconAction:any =  this.setFilePath('action.svg');
  iconAnalysis:any =  this.setFilePath('analysis.svg');
  iconPrevious:any =  this.setFilePath('previous.svg');
  iconDoneCheck:any =  this.setFilePath('done-check.svg');
  iconShowGraph:any =  this.setFilePath('show-graph.svg');
  
  
  @ViewChild('carousel') carousel!: ElementRef;
  @ViewChild('carouselDiv') carouselDiv!: ElementRef;
  @ViewChild('carouselDiv2') carouselDiv2!: ElementRef;

  @ViewChild('modal') modal: TemplateRef<any>;
  @ViewChild('modalFiles') modalFiles: TemplateRef<any>;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private modalService: BsModalService,
    public activatedRoute: ActivatedRoute,
    public myService: ApresentacaoService,
    private apresentacaoResolverId: ApresentacaoResolverId,
    private sanitizer: DomSanitizer,
    private location: Location
  ) { 
    super(activatedRoute); 
  }
  
  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.activatedRoute.queryParamMap.subscribe(params => {
      this.slide = +params.get('slide') - 1;
    });
    this.slide = this.slide >= 0? this.slide:this.slideIndex;
    this.start();
    this.listSlide = this.getSelects();
    this.statusAdm = sessionStorage.getItem('statusMeeting' + this.id) == "true";
  }
  ngAfterViewInit(): void {
     
    setTimeout(() => {
      if(this.print){
        const chart:HTMLCanvasElement = document.querySelector('#chart-graph-'+ this.slide);
        const chartInstance = Chart.getChart(chart as HTMLCanvasElement);
        if(chartInstance){
          chartInstance.resize(500, 300);
          var dataUrl = this.getChartImage(chart);
          const img = document.getElementById('img_' + chart.id) as HTMLImageElement;
          if (img && dataUrl) {
            img.src = dataUrl;
            chart.remove();
            this.graficoCarregado.emit();
          }
        }
        else{
          this.graficoCarregado.emit();
        }
      }
    }, 1000);
  }



  getCarouselWidth(): number{
    return this.carouselDiv?.nativeElement?.offsetWidth 
      ?? this.carouselDiv2?.nativeElement?.offsetWidth 
      ?? ((window.innerWidth/2) - 49);
  }

  start(){
    this.indicators = []
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          this.filters = data.filter;
          this.timers = data.timers;
          var filterAgencies = data.currentFilter?.agency_id ?? [];
          data?.agencyPf?.forEach(ag => {
            var agencyMany = ag?.tb_org_orgao_many; 
            if(agencyMany && agencyMany.length >0){
              agencyMany.forEach(agm =>{
                if(filterAgencies.includes(agm['num_codigo_pk'])){
                  agm.project_full.forEach(pf =>{
                    pf.pf_indicator.forEach((ind, i) =>{
                      this.indicators.push( { ...ind, project: pf, agency:agm, index: i });
                    });
                    this.indicators.push();
                  });
                }
              })
            }
            else{
              if(filterAgencies.includes(ag['num_codigo_pk'])){
                ag.project_full.forEach(pf =>{
                  pf.pf_indicator.forEach(ind =>{
                    this.indicators.push( { ...ind, project: pf, agency:ag});
                  });
                });
              }
            }
          })
          this.currentIndicator = this.indicators[this.slide];
          if(data?.currentAgency == this.currentIndicator?.agency?.num_codigo_pk){
            this.startStopwatch();
          }
          else{
            var newData = {...this.entity, 'currentAgency': null};
            sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(newData));
          }
          this.currentGraph = this.sharedService.getGraph(this.currentIndicator, this.print);
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          console.log(error)
          this.msgError(error.error.message);
        }
      })
  }
  changeSlide(newSlide: number){
    clearInterval(this.interval);
    this.interval = null;
    this.slide = newSlide;
    const url = new URL(window.location.href);
    url.searchParams.set('slide', (newSlide + 1).toString());
    this.location.replaceState(this.location.path().split('?')[0], url.search);
    this.start();
  }

  setFilePath(filePath: string) {
    const fullPath = `assets/images/svgs/${filePath}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }

  getCurrentTime(){
    var agency_id = this.currentIndicator?.agency?.num_codigo_pk;
    
    if(this.timers && agency_id){
      return this.timers[agency_id];
    }
    return 0;
  }
  startStopwatch() {
    var agency_id = this.currentIndicator?.agency?.num_codigo_pk;
    var newTime = this.timers;
    if (!this.interval) { 
      this.interval = setInterval(() => {
        if (newTime[agency_id]  > 0) {
          newTime[agency_id] -= 1000; 
          var data = {...this.entity, 'timers': newTime, 'currentAgency': agency_id};
          sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(data));
        } else {
          this.stopStopwatch();
          console.log("⏳ Tempo esgotado!");
        }
      }, 1000);
    }
  }

  stopStopwatch() {
    clearInterval(this.interval);
    this.interval = null;
    var newData = {...this.entity, 'currentAgency': null};
    sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(newData));
  }

  resetStopwatch() {
    this.stopStopwatch();
    // var project_id = this.currentIndicator?.project?.id;
    var agency_id = this.currentIndicator?.agency?.num_codigo_pk;
    var baseTime = this.entity.timers;
    baseTime[agency_id] = this.entity.baseTimers[agency_id];
    var data = {...this.entity, 'timers': baseTime};
    sessionStorage.setItem('dataMeeting' + this.id, JSON.stringify(data));
  }

  getCurrentMonth(data){
    var currentMonth = null;
    if (data['current_month']) {
      currentMonth = data['current_month'];
    } else {
        if (data['period_mod_id'] == 1 || data['period_mod_id'] == 2) {
            currentMonth = data['month1'];
        } else {
            currentMonth = 1;
        }
    }
    return this.sharedService.getMonth(data, currentMonth);
  }
  
  

//---------------------------------------

  getStatus(line:Criticals){
    var probability_id = line.critical_probability_id;
    var impact_id = line.critical_impact_id;
    if (probability_id == null && impact_id == null) {
      return '';
    }
    var value = (probability_id ?? 0) * (impact_id ?? 0);
    if (probability_id == 10) {
        return 4;
    } else if (value < 9) {
        return 1;
    } else if (value <= 35) {                
        return 2;
    } else if (value <= 81) {
        return 3;
    } else {
        return 4;
    }
  }

  generateLinkProject(item){
    return 'projetos/projeto/' + item?.id + '/cadastro?referer=projeto';
  }
  generateLinkIndicator(ind_id, pf_id){
    return 'projetos/projeto/' + pf_id + '/indicadores/' + ind_id + '?referer=indicador';
  }


  getTimeAsDate(minutes: number): Date {
    const date = new Date(0); 
    date.setMinutes(minutes); 
    return date;
  }
  
  formatData(indicator: PfIndicator, ind: PfIndTable){
    
    /*if (indicator?.period_mod_id == 1 || indicator?.period_mod_id == 2) {
      var currentMonth = item?.month;
    } else { 
      var currentMonth = 1;
    }*/
    var currentMonth = ind?.month
    const validValues = [1, 2, 12];
    if (validValues.includes(indicator?.period_mod_id)){
      var attrList = this.filters?.pfAttrList?.find((a) => a.id === currentMonth);
      if(currentMonth){
        var name = attrList?.label?.slice(0, 3);
        return name;
      }
    }
    else{
      var acPeriodMod = this.filters?.acPeriodMod?.find((a) => a.id === indicator.period_mod_id);
      var name = acPeriodMod?.label?.slice(0, 3);
      return currentMonth + "º" + (name ?? '');
    }
  }

  getDot(indicator: PfIndicator, ind: PfIndTable){
    if (ind.done === null || ind.goal === null) {
      return 0;
    }
    if (ind.done == ind.goal) {
        return 1;
    }
    if (indicator.polarity) {
        var tVar = (ind.done * 100) / (ind.goal == 0 ? 0.0001 : ind.goal);
    } else {
      var tVar = 100 - ((ind.done - ind.goal) * 100) / (ind.goal == 0 ? 0.0001 : ind.goal);
    }
    if (tVar >= parseFloat(indicator.status_ok)) {
        return 1;
    } else if (tVar >= parseFloat(indicator.status_warn)) {
        return 2;
    } else {
        return 3;
    }
  }


  get canGoPrevious(): boolean {
    return this.currentIndex > 0;
  }

  get canGoNext(): boolean {
    return this.currentIndex < this.currentIndicator?.pf_ind_critical.length - this.visibleItems;
  }
  
  next(): void {
    if (this.canGoNext) {
      this.currentIndex++;
      this.updateScroll();
    }
  }

  previous(): void {
    if (this.canGoPrevious) {
      this.currentIndex--;
      this.updateScroll();
    }
  }
  
  private updateScroll(): void {
    const itemWidth = this.carouselDiv.nativeElement.offsetWidth;
    const scrollAmount = this.currentIndex * itemWidth;
    this.carousel.nativeElement.style.transform = `translateX(-${scrollAmount}px)`;
  }
  
  openModal(id:string) {
    this.currentModalId = id;
    this.modalRef = this.modalService.show(this.modal,{class:"modal-g"});
  }

  closeModal() {
    this.modalRef?.hide();
  }
  
  getSelects(){
    var index = this.indicators?.length;
    return Array.from({ length: index }, (_, i) => ({ id: i , label: i + 1  }));
  }
  openFiles(){
    this.loading();
    this.myService.getThumbnails( this.currentIndicator.id ).subscribe({
      next: (data) => {
        this.currentFiles = data;
        this.modalRef = this.modalService.show(this.modalFiles,{class:"modal-g"});
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        console.log(error)
        this.msgError(error.error.message);
      }
    });
  }
  
  getChartImage(canvas: HTMLCanvasElement){
    if (canvas) {
      try {
        const dataURL = canvas.toDataURL('image/png');
        return dataURL;
      } catch (error) {
        return null;
      }
    }
  }
  @HostListener('document:keydown.arrowright', ['$event'])
  onArrowRight(event: KeyboardEvent) {
    event.preventDefault();
    if(this.slide + 1 < this.indicators?.length){
      this.changeSlide(this.slide + 1);
    }
  }

  @HostListener('document:keydown.arrowleft', ['$event'])
  onArrowLeft(event: KeyboardEvent) {
    event.preventDefault();
    if(this.slide > 0){
      this.changeSlide(this.slide - 1);
    }
  }
}
